const MtrStatsOutline = {
  name: 'mtr-stats',
  theme: 'outline',
  icon: {
    tag: 'svg',
    attrs: {
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    children: [
      {},
      {
        tag: 'path',
        attrs: {
          d: 'M9 12L10.4 10.5L12.8 12L15 10',
          stroke: 'currentColor',
          'stroke-width': '1.4',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
        },
      },
      {},
      {
        tag: 'path',
        attrs: {
          'fill-rule': 'evenodd',
          'clip-rule': 'evenodd',
          d:
            'M15.7584 22C16.352 22 16.7712 21.4099 16.5834 20.8384L15.7428 18.7442H18.4168C20.2501 18.7442 21.1668 17.8139 21.1668 15.9535V5.7209C21.1668 5.72071 21.1668 5.72051 21.1668 5.72032H22.0698C22.5836 5.72032 23 5.30384 23 4.79008C23 4.27633 22.5836 3.85985 22.0698 3.85985H18.4302C18.4191 3.85985 18.408 3.86004 18.397 3.86043H12.9168V2.9302C12.9168 2.41644 12.5063 2 12.0001 2C11.4938 2 11.0834 2.41644 11.0834 2.9302V3.86043H4.66669L4.65569 3.86047H1.91667C1.41041 3.86047 1 4.27695 1 4.7907C1 5.30446 1.41041 5.72094 1.91667 5.72094L2.83335 5.72093V15.9535C2.83335 17.8139 3.75002 18.7442 5.58337 18.7442H8.2574L7.41671 20.8384C7.22901 21.4099 7.64814 22 8.24172 22C8.61604 22 8.94836 21.7569 9.06672 21.3966L10.0907 18.7442H13.9094L14.9334 21.3966C15.0518 21.7569 15.3841 22 15.7584 22ZM5.58337 5.7209C5.0771 5.7209 4.66669 6.13738 4.66669 6.65113V15.9535C4.66669 16.4672 5.0771 16.8837 5.58337 16.8837H18.4168C18.9231 16.8837 19.3335 16.4672 19.3335 15.9535V6.65113C19.3335 6.13738 18.9231 5.7209 18.4168 5.7209H5.58337Z',
          fill: 'currentColor',
        },
      },
      {},
    ],
  },
};
export default MtrStatsOutline;
